<app-modal-sanction-type-mel [visible]="shouldShowSanctionTypeModal" [matrix]="sanctionRulesMatrix"
  (handleClose)="closeSanctionTypeModal()">
</app-modal-sanction-type-mel>

<form class="u-bt u-bt--grey u-pt30" [formGroup]="controlForm">
  <div class="row">
    <div class="col-md-12">
      <h2 class="txt txt--section">
        {{formNumber}}. Ingresar sanción
      </h2>
      <h3 class="txt txt--paragraph u-mb20">
        Ingresa los campos necesarios para la infracción.
      </h3>
      <div class="form u-mb30" *ngIf="recommendation">
        <div class="form__alert">
          Infracción {{severityName}} por {{infrigementName}}<br>
          <strong>Recomendación:</strong>
          {{recommendation.recommendation}} <a class="modal__trigger global-hand" (click)="showSanctionTypeModal()">Saber
            más</a>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-4">
      <div class="form form--required u-mb50">
        <label for="" class="label">
          Tipo de sanción <app-tooltip text="Acción disciplinadora."></app-tooltip>
        </label>
        <select formControlName="sanctionTypeId">
          <option value="">Selecciona</option>
          <ng-container *ngFor="let sanctionType of sanctionTypes">
            <option [value]="sanctionType.id">{{sanctionType.name}}</option>
          </ng-container>
        </select>
      </div>
    </div>
    <div class="col-md-4" *ngIf="sanctionIsThis('suspensión')">
      <div class="form form--required u-mb50">
        <label for="" class="label">
          Días de suspensión efectivos
        </label>
        <input type="number" min="0" formControlName="suspensionDays" autocomplete="off">
        <h6 class="form__info">
          *Formato solo numeros.
        </h6>
      </div>
    </div>
    <div class="col-md-4" *ngIf="sanctionIsThis('caducacion')">
      <div class="form form--required u-mb50">
        <label for="" class="label">
          Inicio de la caducación
        </label>
        <app-calendar *ngIf="!defaultDateSetted"  [controlForm]="controlExpirationDate"></app-calendar>
        <app-calendar *ngIf="defaultDateSetted"  [controlForm]="controlExpirationDate" [defaultDate]="defaultDateStart"></app-calendar>
        <app-error-message [text]="controlExpirationDateError"></app-error-message>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-4" *ngIf="sanctionIsThis('suspensión')">
      <div class="form form--required u-mb50">
        <label for="" class="label">
          Inicio de la sanción
        </label>
        <app-calendar *ngIf="!defaultDateSetted" [controlForm]="controlSanctionRangeStart"></app-calendar>
        <app-calendar *ngIf="defaultDateSetted" [controlForm]="controlSanctionRangeStart" [defaultDate]="defaultDateStart"></app-calendar>
        <app-error-message [text]="controlSanctionRangeStartError"></app-error-message>
      </div>
    </div>
    <div class="col-md-4" *ngIf="sanctionIsThis('suspensión')">
      <div class="form form--required u-mb50">
        <label for="" class="label">
          Fin de la sanción
        </label>
        <app-calendar  *ngIf="!defaultDateSetted" [controlForm]="controlSanctionRangeEnd" [canBeUndefined]="true"></app-calendar>
        <app-calendar *ngIf="defaultDateSetted" [controlForm]="controlSanctionRangeEnd" [canBeUndefined]="true" [defaultDate]="defaultDateEnd"></app-calendar>
        <app-error-message [text]="controlSanctionRangeEndError"></app-error-message>
      </div>
    </div>
  </div>

</form>
